import { z } from 'zod';

export const UsefulLifeDueStatusSchema = z.enum(['ON_TIME', 'DUE_SOON', 'CRITICAL']);

export type UsefulLifeDueStatus = z.infer<typeof UsefulLifeDueStatusSchema>;

export const UsefulLifeDueItemKindSchema = z.enum(['PRODUCT', 'SERVICE']);

export type UsefulLifeDueItemKind = z.infer<typeof UsefulLifeDueItemKindSchema>;

export const UsefulLifeDueSourceSchema = z.enum(['THIS_NETWORK', 'INFORMED_OFF_NETWORK']);

export type UsefulLifeDueSource = z.infer<typeof UsefulLifeDueSourceSchema>;

export const GetVehicleUsefulLifeDueQuerySchema = z.object({
  apurationKmMeters: z.coerce.number().int().nonnegative(),
  asOf: z.iso.date().optional(),
});

export type GetVehicleUsefulLifeDueQuery = z.infer<typeof GetVehicleUsefulLifeDueQuerySchema>;

export const UsefulLifeDueItemSchema = z.object({
  identityKey: z.string().min(1),
  itemKind: UsefulLifeDueItemKindSchema,
  displayName: z.string().min(1),
  catalogGenericProductId: z.uuid().nullable(),
  tenantProductId: z.uuid().nullable(),
  serviceCanonicalName: z.string().nullable(),
  serviceTypeCanonicalName: z.string().nullable(),
  lastPerformedAt: z.iso.date(),
  lastPerformedAtKmMeters: z.number().int().nonnegative(),
  usefulLifeMeters: z.number().int().positive().nullable(),
  usefulLifeMonths: z.number().int().positive().nullable(),
  kmPercent: z.number().nullable(),
  timePercent: z.number().nullable(),
  consumptionPercent: z.number(),
  status: UsefulLifeDueStatusSchema,
  kmRemainingMeters: z.number().nullable(),
  timeRemainingMonths: z.number().nullable(),
  source: UsefulLifeDueSourceSchema,
});

export type UsefulLifeDueItem = z.infer<typeof UsefulLifeDueItemSchema>;

export const GetVehicleUsefulLifeDueResponseSchema = z.object({
  plate: z.string().nullable(),
  vehicleLabel: z.string(),
  apurationKmMeters: z.number().int().nonnegative(),
  asOf: z.iso.date(),
  counts: z.object({
    total: z.number().int().nonnegative(),
    critical: z.number().int().nonnegative(),
    dueSoon: z.number().int().nonnegative(),
    onTime: z.number().int().nonnegative(),
    informed: z.number().int().nonnegative(),
  }),
  items: z.array(UsefulLifeDueItemSchema),
});

export type GetVehicleUsefulLifeDueResponse = z.infer<typeof GetVehicleUsefulLifeDueResponseSchema>;

export const RecordInformedOffNetworkCatalogExecutionBodySchema = z.object({
  itemKind: UsefulLifeDueItemKindSchema,
  catalogGenericProductId: z.uuid().optional(),
  tenantProductId: z.uuid().optional(),
  serviceCanonicalName: z.string().trim().min(1).optional(),
  serviceTypeCanonicalName: z.string().trim().min(1).nullable().optional(),
  displayName: z.string().trim().min(1).max(300),
  performedAtKm: z.number().nonnegative().optional(),
  performedAt: z.iso.date().optional(),
});

export type RecordInformedOffNetworkCatalogExecutionBody = z.infer<
  typeof RecordInformedOffNetworkCatalogExecutionBodySchema
>;

export const RecordInformedOffNetworkCatalogExecutionResponseSchema = z.object({
  factId: z.uuid(),
});

export type RecordInformedOffNetworkCatalogExecutionResponse = z.infer<
  typeof RecordInformedOffNetworkCatalogExecutionResponseSchema
>;
